import React from "react";

interface IProps {
  show: boolean,
}

export const ModalHiddenScreen: React.FC<IProps> = (props): JSX.Element => {

  return (
    <>
      {props.show ? (
        <>
          <div id="modal_is_submitting"
            className={`opacity-50 z-50 text-center justify-center flex overflow-x-hidden fixed inset-0 outline-none focus:outline-none`}>
            
            <button type="button" className="w-full h-black bg-black " disabled>
              <div className="display-inline">
              </div>
             
            </button>
          </div>
        </>
      ) : null}
    </>
  );
}